"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _constants = require("@insided/shared/constants");

var InviteUserWarningModal = function InviteUserWarningModal(_ref) {
  var limitEqualToCurrent = _ref.limitEqualToCurrent,
      isOpen = _ref.isOpen,
      onContinueInviting = _ref.onContinueInviting,
      onClose = _ref.onClose;
  var title = limitEqualToCurrent ? "You're about to exceed your seat limit" : "You've exceeded your seat limit";
  var verb = limitEqualToCurrent ? 'will go' : 'went';
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: title,
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, "\uD83C\uDF8A Great that more of your colleagues want to join ", _constants.PLATFORM_BRAND_NAME, "! By inviting a new user, ", verb, " over your current seat limit. That\u2019s no problem - you can still continue. We'll reach out to discuss adjusting your limit, and won\u2019t charge you anything without your consent."), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
    title: "Continue inviting",
    variant: "primary",
    onClick: onContinueInviting,
    className: "qa-continue-invite-user"
  }), (0, _preact.h)(_buttonControl.default, {
    title: "Cancel",
    onClick: function onClick() {
      return onClose();
    }
  })));
};

var _default = InviteUserWarningModal;
exports.default = _default;